import { render } from "./f1_tv.vue?vue&type=template&id=0788c9ae"
import script from "./f1_tv.vue?vue&type=script&lang=js"
export * from "./f1_tv.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__